import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponsePowerDialer } from 'entities/PowerDialer/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponsePowerDialer) => void

export const useEventPowerDialerCreated = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.PdCampaignsCreated, handler), [])
}
